import{classAdderBuilder as s}from"../../common/dist/classadder/classAdderBuilder.js";var a=s({class:"mdc-deprecated-list-item__text",tag:"span"});export{a as default};
//# sourceMappingURL=Text.js.map
